export enum CrudDecoratorPermissionsType {
    ADD = "CrudDecorator.Add",
    UPDATE = "CrudDecorator.Update",
    DELETE = "CrudDecorator.Delete",
    SEARCH = "CrudDecorator.Search"
}
